import { useDashboardToAddToFromParam } from '@modules/analysis/hooks';

export function useGetDashboardTypeDisplayNameFromURLParam(
  dashboardTitle?: string,
) {
  const { context } = useDashboardToAddToFromParam();

  if (context === 'Default') {
    return !!dashboardTitle ? `${dashboardTitle} Dashboard` : 'Dashboard';
  }

  return 'Home';
}
